<template>
  <div class="component-body flex">
    <el-switch v-model="value1">
    </el-switch>
    <el-switch v-model="value1" disabled class="margin-left-10"></el-switch>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      value1: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/10/Switch/index.vue